import { emptyFusionHubApi } from "src/common/service/fusionHub/emptyFusionHubApi";

type AddressSchema = {
	addressId: number;
	addressLine1: string | null;
	addressLine2: string | null;
	addressLine3: string | null;
	postalCode: string | null;
	city: string | null;
	country?: {
		id: string | null;
		name: string | null;
	} | null;
	county?: {
		id: string | null;
		name: string | null;
	} | null;
};

type ContactSchema = {
	contactId: number;
	name: string | null;
	attention: string | null;
	email: string | null;
	web: string | null;
	phone1: string | null;
	phone2: string | null;
	fax: string | null;
};

type BankSettingsSchema = {
	bankName: string | null;
	bankAddress1: string | null;
	bankAddress2: string | null;
	bankAddress3: string | null;
	bankCountry: string | null;
	iban: string | null;
	bban: string | null;
	bbaN2: string | null;
	bbaN3: string | null;
	bic: string | null;
	creditorId: string | null;
};

type BranchSchema = {
	branchId: number;
	number: string;
	name: string | null;
	organizationId: number;
	isMainBranch: boolean;
	isActive: boolean;
	lastModifiedDateTime: string | null;
	corporateId: string;
	vatRegistrationId: string | null;
	mainAddress: AddressSchema | null;
	deliveryAddress: AddressSchema | null;
	mainContact: ContactSchema | null;
	deliveryContact: ContactSchema | null;
	defaultCountry: {
		id: string | null;
		name: string | null;
	} | null;
	industryCode: {
		id: string | null;
		description: string | null;
	} | null;
	currency: {
		id: string | null;
		description: string | null;
		symbol: string | null;
	} | null;
	vatZone: {
		id: string | null;
		description: string | null;
	} | null;
	ledger: {
		id: string | null;
		description: string | null;
	} | null;
	bankSettings: BankSettingsSchema;
};

const vismanetApi = emptyFusionHubApi.injectEndpoints({
	endpoints: (builder) => ({
		createVismanetIntegration: builder.mutation<
			{ integrationId: number },
			{
				companyDomainId: string;
				tenantId: string;
				subAccountSegmentIds: {
					projectId?: number | null;
					costCenterId?: number | null;
				};
			}
		>({
			query: (params) => ({
				url: "/integrations/vismanet/create",
				method: "POST",
				body: params,
			}),
			invalidatesTags: ["Integrations"],
		}),
		listSubAccountSegmentIds: builder.query<
			Array<{ name: string; id: string }>,
			{
				tenantId: string;
			}
		>({
			query: (params) => ({
				url: "/integrations/vismanet/list-sub-account-segment-ids",
				method: "POST",
				body: params,
			}),
		}),
		getVismanetBranch: builder.query<
			BranchSchema,
			{
				tenantId: string;
			}
		>({
			query: (params) => ({
				url: "/integrations/vismanet/get-branch",
				method: "POST",
				body: params,
			}),
		}),
	}),
	overrideExisting: "throw",
});

export const {
	useCreateVismanetIntegrationMutation,
	useGetVismanetBranchQuery,
	useListSubAccountSegmentIdsQuery,
} = vismanetApi;
